import { motion } from "framer-motion";

const CHAPTERS = [
  {
    num: "01",
    title: "The Ray",
    body: "Ray symbolizes vision, light, and clarity. The way you see the world should reflect the confidence you carry within yourself. Eyewear isn't just something you wear — it becomes part of your identity. It tells the world who you are before you say a single word.",
  },
  {
    num: "02",
    title: "The Stance",
    body: "Stance represents confidence, character, and standing firm in who you are. Every frame is designed with purpose, blending luxury, comfort, and timeless style. From the first sketch to the final polish, every detail represents confidence, ambition, and individuality.",
  },
  {
    num: "03",
    title: "The Movement",
    body: "RayStance is for the entrepreneurs chasing their dreams. For the creators changing the culture. For the leaders who aren't afraid to stand apart. For the everyday people who understand that confidence begins the moment they look in the mirror.",
  },
  {
    num: "04",
    title: "The Statement",
    body: "We believe luxury should inspire. Style should empower. And vision should never be ordinary. Every pair of RayStance is more than eyewear — it's confidence you can wear. It's your perspective. It's your story. It's your stance.",
  },
];

export const Manifesto = () => (
  <section id="story" className="relative bg-coal border-y border-white/5" data-testid="story-section">
    <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-32 md:py-48">
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
        className="text-xs uppercase tracking-[0.35em] text-gold mb-24"
      >
        The Story of RayStance
      </motion.p>

      {CHAPTERS.map((c, i) => (
        <motion.div
          key={c.num}
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className={`grid grid-cols-1 md:grid-cols-12 gap-8 ${i > 0 ? "mt-28 md:mt-40" : ""}`}
          data-testid={`manifesto-chapter-${c.num}`}
        >
          <div className="md:col-span-4">
            <div className="md:sticky md:top-32 flex md:flex-col items-baseline md:items-start gap-4">
              <span className="font-serif text-6xl md:text-8xl font-light gold-text-gradient leading-none">
                {c.num}
              </span>
              <span className="font-serif italic text-2xl md:text-3xl text-white">{c.title}</span>
            </div>
          </div>
          <div className="md:col-span-7 md:col-start-6">
            <p className="text-base md:text-lg text-ash leading-loose max-w-2xl">{c.body}</p>
          </div>
        </motion.div>
      ))}
    </div>
  </section>
);
